import { Check, ArrowRight } from "lucide-react";
import { PAYMENT_URL, DARK_TEXTURE } from "../lib/site";
import { SectionHead, Reveal, CtaButton } from "./Reveal";

const DAYS = [
  {
    num: "01",
    label: "Day 01",
    title: "Create With AI",
    topics: [
      "Digital Product Fundamentals",
      "Niche & Product Research",
      "ChatGPT for Product Ideas",
      "AI-Powered Product Creation",
      "Canva Product Design",
      "Live Creation Demonstration",
      "Practical Homework",
    ],
    testId: "curriculum-day1-card",
  },
  {
    num: "02",
    label: "Day 02",
    title: "Launch & Sell",
    topics: [
      "Product Pricing",
      "Landing Page Basics",
      "Payment & Product Delivery",
      "Instagram Marketing",
      "AI Content Creation",
      "Lead Generation & Sales",
      "Seven-Day Launch Action Plan",
      "Live Q&A",
    ],
    testId: "curriculum-day2-card",
  },
];

export default function Curriculum() {
  return (
    <section id="curriculum" data-testid="curriculum-section" className="grain relative overflow-hidden bg-[#1C102D] py-20 sm:py-28">
      <img
        src={DARK_TEXTURE}
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.07]"
      />
      <div className="drift pointer-events-none absolute left-1/2 top-0 h-80 w-[42rem] -translate-x-1/2 rounded-full bg-[#7C3AED]/15 blur-[130px]" />

      <div className="relative mx-auto max-w-6xl px-5 sm:px-8">
        <SectionHead
          dark
          eyebrow="Your Learning Roadmap"
          title={<>Two Days. Real Skills. <span className="bg-gradient-to-r from-[#C9B8F5] to-[#9B5CF0] bg-clip-text text-transparent">Practical Action.</span></>}
          sub="Learn the process, follow the demonstrations and start building your first digital product."
          testId="curriculum"
        />

        <div className="mt-14 grid gap-6 lg:grid-cols-2">
          {DAYS.map((d, i) => (
            <Reveal key={d.num} delay={0.12 + i * 0.15}>
              <div
                data-testid={d.testId}
                className="group relative h-full overflow-hidden rounded-3xl border border-[#39235D] bg-[#24163B]/80 p-8 backdrop-blur-sm transition-[transform,border-color,box-shadow] duration-300 hover:-translate-y-1.5 hover:border-[#9B5CF0]/50 hover:shadow-[0_30px_60px_-20px_rgba(155,92,240,0.3)] sm:p-10"
              >
                <span className="pointer-events-none absolute -right-4 -top-8 select-none text-[9rem] font-extrabold leading-none text-white/[0.04] sm:text-[11rem]">
                  {d.num}
                </span>
                <span className="font-mono text-[11px] font-bold uppercase tracking-[0.3em] text-[#9B5CF0]">{d.label}</span>
                <h3 className="mt-2 text-3xl font-extrabold tracking-tight text-white sm:text-4xl">{d.title}</h3>
                <ul className="mt-7 space-y-3.5">
                  {d.topics.map((t, j) => (
                    <Reveal key={t} delay={0.25 + j * 0.05} y={12}>
                      <li className="flex items-center gap-3 text-[15px] font-medium text-[#D9D2E8]">
                        <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#7C3AED]/25 text-[#C9B8F5]">
                          <Check size={12} strokeWidth={3} />
                        </span>
                        {t}
                      </li>
                    </Reveal>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.35} className="mt-12 text-center">
          <CtaButton href={PAYMENT_URL} testId="curriculum-cta" dark>
            Secure My Seat — ₹199 <ArrowRight size={17} strokeWidth={2.5} />
          </CtaButton>
        </Reveal>
      </div>
    </section>
  );
}
